App.DeliveryCouriersCarriersCarrierController = Ember.Controller.extend
  inappSupport: Em.inject.service()

  actions:
    applyFor: ->
      @transitionToRoute('delivery.couriers.carriers')
      @send('applyForCarrier', @get('model.name'))
      false

    closeModal: ->
      @transitionToRoute('delivery.couriers.carriers')
      false